import request from '@/utils/request'


// 查询师傅推广列表
export function listPromotion(query) {
  return request({
    url: '/master/master-promotion/list',
    method: 'get',
    params: query
  })
}

// 查询师傅推广分页
export function pagePromotion(query) {
  return request({
    url: '/master/master-promotion/page',
    method: 'get',
    params: query
  })
}

// 查询师傅推广详细
export function getPromotion(data) {
  return request({
    url: '/master/master-promotion/detail',
    method: 'get',
    params: data
  })
}

// 新增师傅推广
export function addPromotion(data) {
  return request({
    url: '/master/master-promotion/add',
    method: 'post',
    data: data
  })
}

// 修改师傅推广
export function updatePromotion(data) {
  return request({
    url: '/master/master-promotion/edit',
    method: 'post',
    data: data
  })
}

// 删除师傅推广
export function delPromotion(data) {
  return request({
    url: '/master/master-promotion/delete',
    method: 'post',
    data: data
  })
}
